import _ from 'lodash';
import React, { Component } from 'react';
import { dp, parseTextStyling } from '../../../utils/shared';
import { DEFAULT_CYCLE, LOREM_IPSUM } from './AlbuquerqueConstants';

class AlbuquerqueStoryDoubleImage extends Component {
  constructor(props) {
    super(props);
    this._cycleTimeoutHandler = null;
  }
  
  componentDidMount() {
    this.setupCycle();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  setupCycle = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    this._cycleTimeoutHandler = setTimeout(() => {
      this.props.cycle();
    }, time * 1000)
  }

  getBackground = (i = 0) => {
    let imgObj = _.get(this.props.module, `contents.images[${i}]`, null);
    if (imgObj) {
      return dp(this.props.screen, imgObj, null);
    }
    return null;
  }

  render() {
    const headline = _.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
    const body = _.get(this.props.module, 'contents.custom_fields.body.val', LOREM_IPSUM);
    const headlineRawStyle = _.get(this.props.module, 'contents.custom_fields.headline_style', null);
    const bodyRawStyle = _.get(this.props.module, 'contents.custom_fields.body_style', null);
    const headlineStyle = parseTextStyling(headlineRawStyle);
    const bodyStyle = parseTextStyling(bodyRawStyle);
    const imageLeft = this.getBackground(0);
    const imageRight = this.getBackground(1);

    return (
      <div>
        {/* <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/> */}
        <div style={{ position: "absolute", width: "100%", height: "50vh", top: "26vh", display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ display: "flex", padding: "0 10% 0 10%", flexDirection: "row"}}>
            <div style={{ flex: '0 1 39vh', height: '52vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', padding: '0% 2% 0 4%'}}>
              <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={imageLeft} role='presentation' />
            </div>
            <div style={{ flex: '0 1 39vh', height: '52vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', paddingRight: '4%', paddingLeft: '2%'}}>
              <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={imageRight} role='presentation' />
            </div>
            <div style={{ flex: '1 0 50%'}}>
              <div>
                <div style={{ ...headlineStyle, fontFamily: "legacysans-bold" }}>{headline}</div>
                <br/>
                <div style={{ ...bodyStyle, fontFamily: "legacysans-book" }}>{body}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlbuquerqueStoryDoubleImage;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueStoryDoubleImage.jsx